/* eslint-disable react-hooks/rules-of-hooks */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Container, Row, Col, Modal } from "reactstrap";

import TooltipActivitySummary from "./components/TooltipActivitySummary";

// Redux
import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

import { Duration } from "luxon";
import axios from "axios";

//Assets imports section
import "./ActivitySummary.scss";
import "../../common.scss";
import IconExpand from "../../../Common/IconExpand";
import IconCollapse from "../../../Common/IconCollapse";
import {
  getActivity,
  getSkills,
} from "../../../../../../store/manager/actions";

const index = ({ t, onExpand }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  const {
    dataAgent,
    dataGeneralFilter,
    dataActivity,
    dataSkills,
    loadingActivity,
    loadingSkills,
  } = useSelector((state) => state.Manager);
  const isPorto = useSelector(state => state.Login.data.company.name === 'Porto')

  const userPreferences =
    useSelector((state) => state.Login?.data?.preferences) || {};

  const dispatch = useDispatch();

  const [conversations, setConversations] = useState({
    received: "-",
    assignments: "-",
    abandonment: "-",
    abandonmentPercent: "-",
    finished: "-",
    finishedPercent: "-",
  });

  const [finishedDetails, setFinishedDetails] = useState({
    agent: "-",
    agentPercent: "-",
    system: "-",
    systemPercent: "-",
    manager: "-",
    managerPercent: "-",
    client: "-",
    clientPercent: "-",
  });

  const [tmr, setTMR] = useState({
    first: null,
    general: null,
  });

  const [csat, setCSAT] = useState("-");

  const [csatDetails, setCsatDetails] = useState({
    verySatisfied: "-",
    satisfied: "-",
    neutral: "-",
    dissatisfied: "-",
    veryDissatisfied: "-",
  });

  const [nps, setNPS] = useState("-");

  const [npsDetails, setNpsDetails] = useState({
    promoters: "-",
    neutrals: "-",
    detractors: "-",
  });


  const [capacity, setCapacity] = useState(null);

  const [queue, setQueue] = useState({
    total: "-",
    inAttendance: "-",
  });

  const [lastUpdate, setLastUpdate] = useState(null);
  const [lastInterval, setLastInterval] = useState(null);

  let colorCSAT = csat < 50 ? "#f46a6a" : csat < 70 ? "#ecB14c" : "#34c38f";

  let colorCapacity =
    capacity < 50 ? "#34c38f" : capacity < 70 ? "#ecB14c" : "#f46a6a";

  const [timerControl, setTimeControl] = useState(null);

  const [isOpenFinished, setIsOpenFinished] = useState(false);
  const [isOpenCSAT, setIsOpenCSAT] = useState(false);

  const setActivitiesData = (data) => {
    setConversations({
      received: data?.rcvd_total ?? "-",
      assignments: data?.total_assigned ?? "-",
      abandonment: data?.total_abandoned ?? "-",
      abandonmentPercent: data?.abandon_percentage ?? "-",
      finished: data?.total_closed ?? "-",
      finishedPercent: data?.closed_percentage ?? "-",
    });

    setFinishedDetails({
      agent: data?.by_agent ?? "-",
      agentPercent: data?.by_agent_percentage ?? "-",
      system: data?.by_system ?? "-",
      systemPercent: data?.by_system_percentage ?? "-",
      manager: data?.by_manager ?? "-",
      managerPercent: data?.by_manager_percentage ?? "-",
      client: data?.by_client ?? "-",
      clientPercent: data?.by_client_percentage ?? "-",
    });

    setTMR({
      first:
        data?.first === null
          ? "-"
          : Duration.fromObject({
            seconds: data?.first,
          }).toFormat("mm'm' ss's'"),
      general:
        data?.tmru === null
          ? "-"
          : Duration.fromObject({
            seconds: data?.tmru,
          }).toFormat("mm'm' ss's'"),
    });

    setCSAT(data?.avg_csat ?? "-");
    setCsatDetails({
      verySatisfied: data?.very_satisfied ?? "-",
      satisfied: data?.satisfied ?? "-",
      neutral: data?.neutral ?? "-",
      dissatisfied: data?.unsatisfied ?? "-",
      veryDissatisfied: data?.very_unsatisfied ?? "-",
    });

    setNPS(data?.avg_nps ?? "-");
    setNpsDetails({
      promoters: data?.promoters_nps ?? "-",
      neutrals: data?.neutrals_nps ?? "-",
      detractors: data?.detractors_nps ?? "-",
    });
  };

  const calculateAverageQueue = (data) => {
    setQueue({
      total: data.totalQueueLength ?? "-",
      inAttendance: data.totalAttendanceLength ?? "-",
    });
  };

  useEffect(() => {
    if (dataActivity?.data) {
      setActivitiesData(dataActivity?.data?.general);
    }
  }, [dataActivity]);

  useEffect(() => {
    const { totalQueueLength } = dataSkills?.data ?? {};
    const { in_attendance: totalAttendanceLength } =
      dataActivity?.data?.general ?? {};

    calculateAverageQueue({ totalQueueLength, totalAttendanceLength });
  }, [dataSkills, dataActivity]);

  useEffect(() => {
    dispatch(getActivity(dataGeneralFilter));
    dispatch(getSkills(dataGeneralFilter));
  }, [timerControl, dataGeneralFilter]);

  useEffect(() => {
    const tempCapacity = dataAgent?.totalCapacity;
    if (tempCapacity) {
      setCapacity((tempCapacity * 100).toFixed(2));
    }
  }, [dataAgent]);

  useEffect(() => {
    setLastUpdate(new Date());
    setLastInterval(dataGeneralFilter?.interval ?? 24);
  }, [timerControl]);

  const renderFinishedCard = () => (
    <div className="d-flex justify-content-between">
      <div className="summary-finished">
        <div className="summary-title" id="finishedTitle">
          {t("aFinished")}
        </div>
        <div className="d-flex justify-content-between">
          <div className={`summary-content ${mainTheme}`}>
            {conversations.finished ?? "-"}
          </div>
          {/* <div className="summary-title align-self-end">
            {`• ${conversations.finishedPercent}%`}
          </div> */}
        </div>
        <TooltipActivitySummary
          target="finishedTitle"
          title={t("aFinished")}
          message={t("Number of conversations that were completed")}
          lastUpdate={lastUpdate}
          interval={`${lastInterval}h`}
        />
      </div>
      <div
        className={`summary-btn-expand ${mainTheme}`}
        onClick={() => setIsOpenFinished(!isOpenFinished)}
      >
        {isOpenFinished ? (
          <IconCollapse fill="#BBC4E0" />
        ) : (
          <IconExpand fill="#BBC4E0" />
        )}
      </div>
    </div>
  );

  const renderConversationsCard = () => (
    <div className="d-flex w-100 justify-content-around">
      <div className="summary-received">
        <div className="summary-title" id="receivedTitle">
          {t("Received")}
        </div>
        <div className={`summary-content ${mainTheme}`}>
          {conversations.received ?? "-"}
        </div>
        <TooltipActivitySummary
          target="receivedTitle"
          title={t("Received")}
          message={t(
            "Number of clients who entered the platform (queue or agent)"
          )}
          lastUpdate={lastUpdate}
          interval={`${lastInterval}h`}
        />
      </div>
      <div className="summary-assignments">
        <div className="summary-title" id="assignmentsTitle">
          {t("Assignments")}
        </div>
        <TooltipActivitySummary
          target="assignmentsTitle"
          title={t("Assigned")}
          message={t("Total number of conversations assigned to agents")}
          lastUpdate={lastUpdate}
          interval={`${lastInterval}h`}
        />
        <div className={`summary-content ${mainTheme}`}>
          {conversations.assignments ?? "-"}
        </div>
      </div>
      <div className="summary-abandonment">
        <div className="summary-title" id="abandonedTitle">
          {t("Abandonment")}
        </div>
        <div className="d-flex justify-content-between">
          <div className={`summary-content ${mainTheme}`}>
            {conversations.abandonment ?? "-"}
          </div>
          {/* <div className="summary-title align-self-end">
            {`• ${conversations.abandonmentPercent}%`}
          </div> */}
        </div>
        <TooltipActivitySummary
          target="abandonedTitle"
          title={t("Abandoned")}
          message={t("Number of clients who abandoned attendance")}
          lastUpdate={lastUpdate}
          interval={`${lastInterval}h`}
        />
      </div>
      {renderFinishedCard()}
    </div>
  );

  const renderCsatCard = () => (
    <div className="summary-csat-nps">
      <div className="modal-grid">
        <div className="summary-csat">
          <div className="summary-title">{t("CSAT")}</div>
          <div className={`summary-content ${mainTheme}`}>
            <i className="bx bx-star summary-icon" />
            {`${csat}%`}
          </div>

        </div>
        <div className="vertical-hr" />
        <div className="summary-nps">
          <div className="summary-title">{t("NPS")}</div>
          <div className={`summary-content ${mainTheme} summary-content-nps`}>
            <i className="bx bx-tachometer summary-icon summary-icon-nps" />
            {`${nps}`}</div>
        </div>
      </div>
      <div
        className={`summary-btn-expand ${mainTheme} summary-btn-hover`}
        onClick={() => setIsOpenCSAT((prev) => !prev)}
      >
        {isOpenCSAT ? (
          <IconCollapse fill="#BBC4E0" />
        ) : (
          <IconExpand fill="#BBC4E0" />
        )}
      </div>
    </div>
  );

  return (
    <>
      <Container className="d-flex w-100 px-0 mx-2" fluid={true}>
        <Row className="w-100 mx-0">
          <Col className="d-flex px-0" xs="12">
            <span className={`section-title ${mainTheme}`}>
              {t("Activity Summary")}
            </span>
            <button
              className={`conversation-header-button-wrapper small-light mx-2`}
              onClick={() => setTimeControl(new Date())}
              disabled={loadingActivity || loadingSkills}
            >
              <i
                className={`bx bx-refresh bx-xs mr-0 align-self-center header-button-icons header-button-refresh ${loadingActivity || loadingSkills ? "loading-spinning" : ""
                  }`}
              />
            </button>
          </Col>

          <div
            className={`d-flex flex-wrap flex-grow-1 justify-content-between overflow-auto px-0 mt-2`}
          >
            <div className={`summary conversations ${mainTheme} overflow`}>
              {renderConversationsCard()}
            </div>
            <div className={`summary tmr ${mainTheme}`}>
              <div className="summary-tmr-first">
                <div className="summary-title">{t("ART 1º response")}</div>
                <div className={`summary-content ${mainTheme}`}>
                  {tmr.first ?? "-"}
                </div>
              </div>
              <div className="summary-tmr-general">
                <div className="summary-title">{t("ART General")}</div>
                <div className={`summary-content ${mainTheme}`}>
                  {tmr.general ?? "-"}
                </div>
              </div>
            </div>
            <div
              className={`summary csat ${mainTheme}`}
              style={{ "--color": colorCSAT }}
            >
              {renderCsatCard()}
            </div>
            <div
              className={`summary capacity ${mainTheme}`}
              style={{ "--color": colorCapacity }}
            >
              <div className="summary-capacity">
                <div className="summary-title">{t("Capacity")}</div>
                <div className={`summary-content ${mainTheme}`}>
                  {`${capacity ?? "-"}%`}
                </div>
              </div>
            </div>
            <div className={`summary queue ${mainTheme}`}>
              <div className="summary-total">
                <div className="summary-title">{t("Queue total")}</div>
                <div className={`summary-content ${mainTheme}`}>
                  {queue.total ?? "-"}
                </div>
              </div>
              <div className="summary-in-attendance">
                <div className="summary-title">{t("In attendance")}</div>
                <div className={`summary-content ${mainTheme}`}>
                  {!isPorto ? queue.inAttendance ?? "-" : '-'}
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
      <Modal
        contentClassName="details-modal"
        isOpen={isOpenFinished}
        toggle={() => setIsOpenFinished(!isOpenFinished)}
      >
        <div
          className={`summary d-block ${mainTheme} mr-0 mb-0`}
          style={{ "--color": colorCSAT }}
        >
          {renderFinishedCard()}
          <hr className="details-hr" />
          <div>
            <div className="d-flex w-100 justify-content-between mb-3">
              <div>
                <div className={`details-title ${mainTheme}`}>{t("Agent")}</div>
                <div className="d-flex justify-content-between">
                  <div className={`details-content ${mainTheme}`}>
                    {finishedDetails.agent}
                  </div>
                  {/* <div className="summary-title font-weight-normal align-self-end">
                      {`• ${finishedDetails.agentPercent}%`}
                    </div> */}
                </div>
              </div>
              <div>
                <div className={`details-title ${mainTheme}`}>
                  {t("System")}
                </div>
                <div className="d-flex justify-content-between">
                  <div className={`details-content ${mainTheme}`}>
                    {finishedDetails.system}
                  </div>
                  {/* <div className="summary-title font-weight-normal align-self-end">
                      {`• ${finishedDetails.systemPercent}%`}
                    </div> */}
                </div>
              </div>
            </div>
            <div className="d-flex w-100 justify-content-between">
              <div>
                <div className={`details-title ${mainTheme}`}>
                  {t("Manager")}
                </div>
                <div className="d-flex justify-content-between">
                  <div className={`details-content ${mainTheme}`}>
                    {finishedDetails.manager}
                  </div>
                  {/* <div className="summary-title font-weight-normal align-self-end">
                      {`• ${finishedDetails.managerPercent}%`}
                    </div> */}
                </div>
              </div>
              <div>
                <div className={`details-title ${mainTheme}`}>
                  {t("Client")}
                </div>
                <div className="d-flex justify-content-between">
                  <div className={`details-content ${mainTheme}`}>
                    {finishedDetails.client}
                  </div>
                  {/* <div className="summary-title font-weight-normal align-self-end">
                      {`• ${finishedDetails.clientPercent}%`}
                    </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        contentClassName="details-modal"
        isOpen={isOpenCSAT}
        toggle={() => setIsOpenCSAT(!isOpenCSAT)}
      >
        <div
          className={`summary csat ${mainTheme} d-block mr-0 mb-0`}
          style={{ "--color": colorCSAT }}
        >
          {renderCsatCard()}
          <hr className="details-hr" />
          <div className="modal-grid">
            <div className="summary-grid">
              <div className={`details-content ${mainTheme}`}>
                {csatDetails.verySatisfied}
              </div>
              <div className={`details-title ${mainTheme}`}>
                {t("Very satisfied")}
              </div>
              <div className={`details-content ${mainTheme}`}>
                {csatDetails.satisfied}
              </div>
              <div className={`details-title ${mainTheme}`}>
                {t("Satisfied")}
              </div>
              <div className={`details-content ${mainTheme}`}>
                {csatDetails.neutral}
              </div>
              <div className={`details-title ${mainTheme}`}>{t("Neutral")}</div>
              <div className={`details-content ${mainTheme}`}>
                {csatDetails.dissatisfied}
              </div>
              <div className={`details-title ${mainTheme}`}>
                {t("Dissatisfied")}
              </div>
              <div className={`details-content ${mainTheme}`}>
                {csatDetails.veryDissatisfied}
              </div>
              <div className={`details-title ${mainTheme}`}>
                {t("Very dissatisfied")}
              </div>
            </div>
            <div className="vertical-hr" />
            <div className="summary-grid">
              <div className={`details-content ${mainTheme}`}>
                {npsDetails.promoters}
              </div>
              <div className={`details-title ${mainTheme}`}>
                {t("Promoters")}
              </div>
              <div className={`details-content ${mainTheme}`}>
                {npsDetails.neutrals}
              </div>
              <div className={`details-title ${mainTheme}`}>
                {t("Neutrals")}
              </div>
              <div className={`details-content ${mainTheme}`}>
                {npsDetails.detractors}
              </div>
              <div className={`details-title ${mainTheme}`}>
                {t("Detractors")}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default withTranslation()(index);
